import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

const isSessionStorageSupported = () => {
    return typeof window !== "undefined" && "sessionStorage" in window;
};

const encode = (value: unknown): string => JSON.stringify(value);

const decode = <T>(value: string | null): T | null => {
    if (value === null) {
        return null;
    }

    try {
        return JSON.parse(value) as T;
    } catch {
        return null;
    }
};

/**
 * sessionCache is a wrapper around sessionStorage with API similar to lscache.
 * Data stored here persists only for the browser session (cleared when tab/browser is closed).
 */
export const sessionCache = {
    set(key: string, value: boolean | string | number | object) {
        if (!isSessionStorageSupported()) {
            return;
        }

        try {
            window.sessionStorage.setItem(key, encode(value));
        } catch (error) {
            notifyBugsnagClient(new Error(`SessionStorage set error for key: ${key}`), String(error));
        }
    },
    get<T>(key: string): T | null {
        if (!isSessionStorageSupported()) {
            return null;
        }

        try {
            const rawValue = window.sessionStorage.getItem(key);
            return decode<T>(rawValue);
        } catch (error) {
            notifyBugsnagClient(new Error(`SessionStorage get error for key: ${key}`), String(error));
            return null;
        }
    },
    remove(key: string) {
        if (!isSessionStorageSupported()) {
            return;
        }

        try {
            window.sessionStorage.removeItem(key);
        } catch (error) {
            notifyBugsnagClient(new Error(`SessionStorage remove error for key: ${key}`), String(error));
        }
    }
};
import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

const isSessionStorageSupported = () => {
    return typeof window !== "undefined" && "sessionStorage" in window;
};

const encode = (value: unknown): string => JSON.stringify(value);

const decode = <T>(value: string | null): T | null => {
    if (value === null) {
        return null;
    }

    try {
        return JSON.parse(value) as T;
    } catch {
        return null;
    }
};

/**
 * sessionCache is a wrapper around sessionStorage with API similar to lscache.
 * Data stored here persists only for the browser session (cleared when tab/browser is closed).
 */
export const sessionCache = {
    set(key: string, value: boolean | string | number | object) {
        if (!isSessionStorageSupported()) {
            return;
        }

        try {
            window.sessionStorage.setItem(key, encode(value));
        } catch (error) {
            notifyBugsnagClient(new Error(`SessionStorage set error for key: ${key}`), String(error));
        }
    },
    get<T>(key: string): T | null {
        if (!isSessionStorageSupported()) {
            return null;
        }

        try {
            const rawValue = window.sessionStorage.getItem(key);
            return decode<T>(rawValue);
        } catch (error) {
            notifyBugsnagClient(new Error(`SessionStorage get error for key: ${key}`), String(error));
            return null;
        }
    },
    remove(key: string) {
        if (!isSessionStorageSupported()) {
            return;
        }

        try {
            window.sessionStorage.removeItem(key);
        } catch (error) {
            notifyBugsnagClient(new Error(`SessionStorage remove error for key: ${key}`), String(error));
        }
    }
};
